import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import CompanyName from '../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import Decision from '../../commonComponents/Decision';
import { DecisionType } from '../../../static/types/commonTypes/decisionType';
import LegalEntity from '../../commonComponents/LegalEntity';
import { LegalEntityType } from '../../../static/types/commonTypes/legalEntityType';
import ChangeSocialObject from '../../change-social-object/ChangeSocialObject';
import { ChangeSocialObjectType } from '../../../static/types/changeSocialObjective/changeSocialObjectType';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import DecisionWithQuality from '../../commonComponents/DecisionWithQuality';
import { formatObjectText } from '../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    activeIndex: number;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const ModificationObjetSocial: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        decisionWithEffectiveDate, setDecisionWithEffectiveDate,
        decisionWithEffectiveDateValidity, setDecisionWithEffectiveDateValidity,
        decisionWithEffectiveDateChecked, setDecisionWithEffectiveDateChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,

        changeSocialObject, setChangeSocialObject,
        changeSocialObjectValidity, setChangeSocialObjectValidity,
        changeSocialObjectChecked, setChangeSocialObjectChecked,

        decisionWithQualityAndEffectiveDate,
        setDecisionWithQualityAndEffectiveDate,
        decisionWithQualityAndEffectiveDateValidity,
        setDecisionWithQualityAndEffectiveDateValidity,
        decisionWithQualityAndEffectiveDateChecked,
        setDecisionWithQualityAndEffectiveDateChecked,

    } = useAppContext() as AppContextType;

    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);

    const handleNext = () => {
        if (activeTab === "companyName") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("companyName"));
            }
        } else if (activeTab === "decision") {
            setDecisionWithQualityAndEffectiveDateChecked(true)
            if (decisionWithQualityAndEffectiveDateValidity) {
                switchTab(getNextTab("decision"));
            }
        } else if (activeTab === "theSociety") {
            setLegalEntityChecked(true)
            if (legalEntityValidity) {
                switchTab(getNextTab("theSociety"));
            }
        } else if (activeTab === "socialObjectifUpdate") {
            setChangeSocialObjectChecked(true)
            if (changeSocialObjectValidity) {
                setSubmissive(true)
            }
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));

        setSubmissive(false);
    }
    const getNextTab = (currentTab: string) => {
        if (currentTab === "companyName") return "decision";
        else if (currentTab === "decision") return "theSociety";
        else if (currentTab === "theSociety") return "socialObjectifUpdate";
        else return currentTab;
    };

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "socialObjectifUpdate") return "theSociety";
        else if (currentTab === "theSociety") return "decision";
        else if (currentTab === "decision") return "companyName";
        else return currentTab;
    };

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validate()) {
            const pluralSubjects = ["Les associés","Les actionnaires"];

            const verb = pluralSubjects.includes(decisionWithQualityAndEffectiveDate.decisionQuality) ? "ont" : "a";
            const tempText = `${companyName.companyName},
${legalEntity.legalForm} au capital de ${legalEntity.capital} €.
Siège social :
 ${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city}
 ${legalEntity.rcs} RCS ${getCityWithPreposition(legalEntity.registrationOffice)}     
${firstPartDecision.includes(decisionWithQualityAndEffectiveDate.decisionNature) ? `Aux termes de l'${decisionWithQualityAndEffectiveDate.decisionNature} en date du ${decisionWithQualityAndEffectiveDate.decisionDate} ${decisionWithQualityAndEffectiveDate.decisionQuality} ${verb}`: `Le ${decisionWithQualityAndEffectiveDate.decisionDate} ${decisionWithQualityAndEffectiveDate.decisionNature.toLowerCase()} ${verb}`
} décidé ${(changeSocialObject.type || "extension") === 'extension' ? "d'étendre" : "de modifier"} l'objet social à : ${changeSocialObject.socialObject} à compter du ${decisionWithQualityAndEffectiveDate.effectiveDate}.
 Mention au RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
        }
    };

    const firstPartDecision = [
        "AG Extraordinaire",
        "AG Ordinaire",
        "AG Mixte"
    ]

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab("companyName")
        } else if (!decisionWithQualityAndEffectiveDateValidity) {
            setActiveTab("decision")
        } else if (!legalEntityValidity) {
            setActiveTab("theSociety")
        } else if (!changeSocialObjectValidity) {
            setActiveTab("socialObjectifUpdate")
        }

        return companyNameValidity && decisionWithQualityAndEffectiveDateValidity && legalEntityValidity && changeSocialObjectValidity
    };

    const goToSupportPresse = () => { updateActiveIndex(2); }

    const [submissive, setSubmissive] = useState<boolean>(false)

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });

    const updateDecision = (data: Partial<DecisionType>) => setDecisionWithQualityAndEffectiveDate({ ...decisionWithQualityAndEffectiveDate, ...data });


    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType]


    const tabs = [ 
        {key: 'companyName', label: 'Raison Sociale'},
        {key: 'decision', label: 'La décision'},
        {key: 'theSociety', label: 'La société'},
        {key: 'socialObjectifUpdate', label: 'Nouvel objectif social'}
    ]

    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' &&
                    <div>
                        <span className='mb-2'>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={updateCompanyName}
                                checked={companyNameChecked}
                                companyName={companyName}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                                showClientReference={true}
                            />
                        </div>
                    </div>
                }

                {
                    activeTab === 'decision' &&
                    <DecisionWithQuality
                        decisionWithQuality={decisionWithQualityAndEffectiveDate}
                        draftFieldName = 'decisionWithQualityAndEffectiveDate'
                        checked={decisionWithQualityAndEffectiveDateChecked}
                        dateLabel='Date'
                        changeDecision={updateDecision}
                        onValidationChange={(isValid: boolean) => setDecisionWithQualityAndEffectiveDateValidity(isValid)}
                        decisionQualityOptions={[
                            "L'associé unique",
                            "Les associés",
                            "Les actionnaires"
                        ]}
                        decisionNatureOptions={[
                            "AG Extraordinaire",
                            "AG Ordinaire",
                            "AG Mixte",
                            "Le gérant",
                            "Le président",
                            "Le conseil d'administration",
                            "Décision unanime des associés"
                        ]}
                    />
                }

                {
                    activeTab === 'theSociety' &&
                    <LegalEntity
                        changeLegalEntity={(partialData: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...partialData })}
                        checked={legalEntityChecked}
                        legalEntity={legalEntity}
                        onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                        companyName={companyName}
                        setCompanyName={(partialData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...partialData })}
                        societyType={societyTypeOptions}
                        draftFieldName = 'legalEntity'
                    />
                }

                {
                    activeTab === 'socialObjectifUpdate' &&
                    <div>
                        <span>
                            L'objet social peut selon le cas être étendu à de nouvelles activités (Extension), ou remplacé par un tout nouvel objet (Modification).
                        </span>
                        <ChangeSocialObject
                            labelText='Objet social'
                            checked={changeSocialObjectChecked}
                            socialObject={changeSocialObject}
                            onValidationChange={(isValid: boolean) => setChangeSocialObjectValidity(isValid)}
                            changeSocialObject={(partialData: Partial<ChangeSocialObjectType>) => setChangeSocialObject({ ...changeSocialObject, ...partialData })}
                        />
                    </div>
                }

                {
                    submissive &&
                    activeTab === 'socialObjectifUpdate' &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                            )}

                        {
                            activeTab === 'socialObjectifUpdate' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            activeTab !== 'socialObjectifUpdate' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            submissive && activeTab === 'socialObjectifUpdate' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}
                    </div>
                </div>

            </form>
        </>
    );
};

export default ModificationObjetSocial;